import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/brand.css";
import "./i18n";
// Card #3095 — load the Sentry/GlitchTip SDK module before the first render.
// The actual `Sentry.init()` fires later from ConfigProvider once the runtime
// config envelope (which carries the DSN) is hydrated. We import here so the
// SDK code is in the bundle critical path and ready to capture errors the
// instant the DSN lands. If the envelope has no DSN, init is a no-op.
import "./lib/sentryInit";
import { AppFleet } from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppFleet />
  </React.StrictMode>,
);
